<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }

  <mat-select
    #userSelect
    [id]="'user-search-' + controlName"
    [formControl]="control"
    [placeholder]="placeholder"
    [matTooltip]="getSelectCount() > 1 ? displayTooltip() : ''"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    [multiple]="multiple"
    [required]="required">

    @if (multiple) {
      <mat-select-trigger>
        @if (getSelectCount() === 1) {
          <span>
            {{((getSingleModeValue()?.user?.given_name || '') + ' ' + (getSingleModeValue()?.user?.family_name || '')).trim()}}
          </span>
        }
        @if (getSelectCount() > 1 && (getSelectCount() - displayOptionLengthFeatureSubtract) == userOptions.length) {
          <span>
            All
          </span>
        }
        @if (getSelectCount() > 1 && (getSelectCount() - displayOptionLengthFeatureSubtract) < userOptions.length) {
          <span>
            Multiple
          </span>
        }
        @if (getSelectCount() > 1) {
          <span>
            ({{getSelectCount()}})
          </span>
        }
      </mat-select-trigger>
    }

    <mat-option>
      <ngx-mat-select-search
        placeholderLabel="search..."
        noEntriesFoundLabel="No Users Found"
        [id]="'filter-' + controlName"
        [formControl]="filterControl"
        [showToggleAllCheckbox]="multiple"
        [toggleAllCheckboxChecked]="allToggled"
        [toggleAllCheckboxIndeterminate]="indeterminateToggle"
      (toggleAll)="onToggleAll($event)"></ngx-mat-select-search>
    </mat-option>

    @if (unassignedEnabled) {
      <mat-option
        #unassignedItem
        [value]="unassignedOption"
        (click)="unassignedOption.selected = unassignedItem.selected">
        {{unassignedOption.user.given_name}} {{unassignedOption.user.family_name}}
      </mat-option>
    }

    @for (option of filteredOptions | async; track option) {
      <mat-option
        #selectItem
        [value]="option"
        (click)="toggleSelection(selectItem, option)">
        {{option.user.given_name}} {{option.user.family_name}}
      </mat-option>
    }

  </mat-select>

  @if (control.hasError('required')) {
    <mat-error>Selection is <strong>required</strong></mat-error>
  }
</mat-form-field>
